// extracted by mini-css-extract-plugin
export var icon = "DocumentMenu-module--icon--Cp3Nd";
export var menu = "DocumentMenu-module--menu--IL5-r";
export var menuItem = "DocumentMenu-module--menuItem--RTKM+";
export var purchased = "DocumentMenu-module--purchased--Nry4k";